'use client'

import { createContext, type ReactNode, useContext, useMemo } from 'react'

import { type FloatingToggleType } from '@/defs/floating'

type FloatingContext = {
  close: () => void
}

const FloatingContext = createContext<FloatingContext | null>(null)

type Props = {
  children: ReactNode
} & Pick<FloatingToggleType, 'setIsOpen'>

export const FloatingProvider = ({ children, setIsOpen }: Props) => {
  const value = useMemo(() => ({ close: () => setIsOpen(false) }), [setIsOpen])

  return <FloatingContext.Provider value={value}>{children}</FloatingContext.Provider>
}

export const useFloating = () => {
  const floating = useContext(FloatingContext)

  if (!floating) throw new Error('useFloating must be used within a modal, popover, or dropdown')

  return floating
}
